jQuery(document).ready(function ($) {

    'use strict';


    /* =========================================================
       DEVICE DETECTION
    ========================================================= */

    function isMobile() {

        return window.matchMedia(
            '(max-width: 575.98px)'
        ).matches;

    }


    function isTouchDevice() {

        return (
            window.matchMedia(
                '(pointer: coarse)'
            ).matches ||
            window.matchMedia(
                '(hover: none)'
            ).matches ||
            navigator.maxTouchPoints > 0
        );

    }


    function isTablet() {

        if (isMobile()) {
            return false;
        }

        const normalTablet =
            window.matchMedia(
                '(min-width: 576px) and (max-width: 991.98px)'
            ).matches;

        /*
         * Tablet landscape kan > 992px zijn.
         *
         * Een touch device tot 1366px behandelen we
         * daarom nog steeds als tablet.
         */

        const largeTouchTablet =
            isTouchDevice() &&
            window.matchMedia(
                '(max-width: 1366px)'
            ).matches;

        return (
            normalTablet ||
            largeTouchTablet
        );

    }


    /*
     * Tablet landscape.
     *
     * Dit blijft technisch een tablet,
     * maar krijgt verder desktop-gedrag.
     */

    function isTabletLandscape() {

        return (
            isTablet() &&
            window.matchMedia(
                '(orientation: landscape)'
            ).matches
        );

    }


    function isDesktop() {

        return (
            !isMobile() &&
            !isTablet()
        );

    }


    /*
     * Desktop-gedrag:
     *
     * echte desktop
     * +
     * tablet landscape
     */

    function isDesktopLike() {

        return (
            isDesktop() ||
            isTabletLandscape()
        );

    }


    function getDeviceType() {

        if (isMobile()) {
            return 'mobile';
        }

        if (isTabletLandscape()) {
            return 'tablet-landscape';
        }

        if (isTablet()) {
            return 'tablet';
        }

        return 'desktop';

    }


    /* =========================================================
       TABLET LANDSCAPE CLASS
    ========================================================= */

    function updateTabletLandscapeClass() {

        $('body').toggleClass(
            'tablet-landscape',
            isTabletLandscape()
        );

    }


    /* =========================================================
       INFO KEYBOARD
    ========================================================= */

    function updateKeyboardInfoVisibility() {

        const info =
            $('.info-keyboard');

        if (!info.length) {
            return;
        }

        /*
         * Alleen echte desktop toont info-keyboard.
         *
         * Tablet landscape gebruikt desktop-functionaliteit,
         * maar toont de keyboard-info NIET.
         */

        if (isDesktop()) {

            info.css(
                'display',
                ''
            );

        } else {

            info.css(
                'display',
                'none'
            );

        }

    }


    updateTabletLandscapeClass();

    updateKeyboardInfoVisibility();


    /* =========================================================
       MOBILE MENU RANDOMIZER
    ========================================================= */

    function randomizeMobileMenuProjects() {

        if (!isMobile()) {
            return;
        }

        $('.inner-projects-list').each(function () {

            const list = $(this);

            const items =
                list.find(
                    '.project-link'
                ).get();

            if (items.length < 2) {
                return;
            }

            for (
                let i = items.length - 1;
                i > 0;
                i--
            ) {

                const j =
                    Math.floor(
                        Math.random() *
                        (i + 1)
                    );

                const temp =
                    items[i];

                items[i] =
                    items[j];

                items[j] =
                    temp;

            }

            $.each(
                items,
                function (_, item) {

                    list.append(item);

                }
            );

        });

    }


    randomizeMobileMenuProjects();


    /* =========================================================
       OPENING
    ========================================================= */

    const opening =
        $('#opening');

    const seen =
        sessionStorage.getItem(
            'openingSeen'
        );

    if (seen === '1') {

        opening.remove();

    } else {

        opening.css(
            'display',
            'block'
        );

    }


    /* =========================================================
       REQUESTED PROJECT
    ========================================================= */

    function getRequestedProjectSlug() {

        const params =
            new URLSearchParams(
                window.location.search
            );

        return (
            params.get('project') ||
            null
        );

    }


    const requestedProjectSlug =
        getRequestedProjectSlug();


    /* =========================================================
       MENU
    ========================================================= */

    $(document).on(
        'click',
        '#1',
        function (e) {

            e.preventDefault();
            e.stopPropagation();

            $('header').toggleClass(
                'menuopen'
            );

            $('body').toggleClass(
                'mo'
            );

            $('header').removeClass(
                'contactopen detailsopen'
            );

            $('body').removeClass(
                'co do'
            );

        }
    );


    $(document).on(
        'click',
        '#menu-close',
        function (e) {

            e.preventDefault();
            e.stopPropagation();

            $('header').removeClass(
                'menuopen contactopen detailsopen'
            );

            $('body').removeClass(
                'mo co do'
            );

        }
    );


    /* =========================================================
       CONTACT
    ========================================================= */

    $(document).on(
        'click',
        '#c',
        function (e) {

            e.preventDefault();
            e.stopPropagation();

            const isOpen =
                $('header').hasClass(
                    'contactopen'
                );

            $('header').removeClass(
                'menuopen detailsopen'
            );

            $('body').removeClass(
                'mo do'
            );

            if (isOpen) {

                $('header').removeClass(
                    'contactopen'
                );

                $('body').removeClass(
                    'co'
                );

            } else {

                $('header').addClass(
                    'contactopen'
                );

                $('body').addClass(
                    'co'
                );

            }

        }
    );


    /* =========================================================
       DETAILS
    ========================================================= */

    $(document).on(
        'click',
        '#2',
        function (e) {

            e.preventDefault();
            e.stopPropagation();

            const isOpen =
                $('header').hasClass(
                    'detailsopen'
                );

            $('header').removeClass(
                'menuopen contactopen'
            );

            $('body').removeClass(
                'mo co'
            );

            if (isOpen) {

                $('header').removeClass(
                    'detailsopen'
                );

                $('body').removeClass(
                    'do'
                );

            } else {

                $('header').addClass(
                    'detailsopen'
                );

                $('body').addClass(
                    'do'
                );

            }

        }
    );


    /* =========================================================
       MENU CONTACT
    ========================================================= */

    $(document).on(
        'click',
        '#menu-contact',
        function (e) {

            e.preventDefault();
            e.stopPropagation();

            $('.menu').addClass(
                'contactopen'
            );

            $('.menu').removeClass(
                'projectsopen'
            );

        }
    );


    /* =========================================================
       MENU PROJECTS
    ========================================================= */

    $(document).on(
        'click',
        '#menu-projects',
        function (e) {

            e.preventDefault();
            e.stopPropagation();

            $('.menu').addClass(
                'projectsopen'
            );

            $('.menu').removeClass(
                'contactopen'
            );

        }
    );


    /* =========================================================
       PROJECT LINKS
    ========================================================= */

    $(document).on(
        'click',
        '.project-link',
        function () {

            $('header').removeClass(
                'menuopen detailsopen contactopen'
            );

            $('body').removeClass(
                'mo co do'
            );

        }
    );


    /* =========================================================
       ESCAPE
    ========================================================= */

    $(document).on(
        'keydown',
        function (event) {

            if (
                event.key !== 'Escape'
            ) {
                return;
            }

            $('header').removeClass(
                'menuopen contactopen detailsopen'
            );

            $('body').removeClass(
                'mo co do'
            );

            if (opening.length) {

                opening.css(
                    'display',
                    'none'
                );

            }

        }
    );


    /* =========================================================
       OPENING - HELE SCHERM KLIKBAAR
    ========================================================= */

    $(document).on(
        'click',
        '#opening',
        function () {

            $('#opening').fadeOut(
                300,
                function () {

                    $(this).css(
                        'display',
                        'none'
                    );

                }
            );

            sessionStorage.setItem(
                'openingSeen',
                '1'
            );

        }
    );


    /* =========================================================
       MAIN SWIPER
    ========================================================= */

    const mainElement =
        $('.swiper-container').first()[0];

    if (!mainElement) {
        return;
    }


    const mySwiper =
        new Swiper(
            mainElement,
            {

                loop: false,

                direction: 'horizontal',

                preloadImages: false,

                watchOverflow: true,

                allowTouchMove:
                    !isMobile(),

                threshold: 20,

                touchRatio: 1,

                touchAngle: 45,

                resistance: true,

                resistanceRatio: 0.85,

                touchReleaseOnEdges: false,

                mousewheel:
                    isMobile()
                        ? false
                        : {
                            forceToAxis: true,
                            sensitivity: 3,
                            releaseOnEdges: true
                        },

                keyboard: {
                    enabled: false
                },

                pagination: {

                    el:
                        '.swiper-pagination',

                    dynamicBullets: true,

                    clickable:
                        !isMobile()

                },

                navigation: {

                    nextEl:
                        '.swiper-pointer-next',

                    prevEl:
                        '.swiper-pointer-prev'

                },

                preventClicks: false,

                preventClicksPropagation: false,

                observer: false,

                observeParents: false

            }
        );


    /* =========================================================
       OPENING + TOUCH
    ========================================================= */

    mySwiper.on(
        'touchStart',
        function () {

            if (
                opening.length &&
                opening.is(':visible')
            ) {

                opening.fadeOut(200);

                sessionStorage.setItem(
                    'openingSeen',
                    '1'
                );

            }

        }
    );


    /* =========================================================
       IMAGE RULES
    ========================================================= */

    function imageIsMobileOnly(slide) {

        return (
            slide &&
            slide.dataset.mobileOnly === '1'
        );

    }


    function imageIsDesktopOnly(slide) {

        return (
            slide &&
            slide.dataset.desktopOnly === '1'
        );

    }


    /*
     * Bepaalt of een afbeelding onderdeel van de
     * huidige Swiper mag zijn.
     *
     * mobile-only:
     * mobile + tablet portrait
     *
     * desktop-only:
     * desktop + tablet landscape
     */

    function imageIsAllowed(slide) {

        if (!slide) {
            return false;
        }

        const mobileOnly =
            imageIsMobileOnly(slide);

        const desktopOnly =
            imageIsDesktopOnly(slide);


        /*
         * Beide actief = nooit tonen.
         */

        if (
            mobileOnly &&
            desktopOnly
        ) {
            return false;
        }


        /* -----------------------------------------------------
           MOBILE
        ----------------------------------------------------- */

        if (isMobile()) {

            if (desktopOnly) {
                return false;
            }

            return true;

        }


        /* -----------------------------------------------------
           TABLET PORTRAIT
        ----------------------------------------------------- */

        if (
            isTablet() &&
            !isTabletLandscape()
        ) {

            if (desktopOnly) {
                return false;
            }

            return true;

        }


        /* -----------------------------------------------------
           DESKTOP + TABLET LANDSCAPE
        ----------------------------------------------------- */

        if (isDesktopLike()) {

            if (mobileOnly) {
                return false;
            }

            return true;

        }

        return true;

    }


    /* =========================================================
       STORE ORIGINAL INNER SLIDES
    ========================================================= */

    function storeOriginalSlides(
        projectContainer
    ) {

        if (!projectContainer) {
            return;
        }

        const wrapper =
            projectContainer.querySelector(
                '.swiper-wrapper'
            );

        if (!wrapper) {
            return;
        }

        if (
            wrapper.dataset.originalHtmlStored === '1'
        ) {
            return;
        }

        wrapper.dataset.originalHtml =
            wrapper.innerHTML;

        wrapper.dataset.originalHtmlStored =
            '1';

    }


    /* =========================================================
       RESTORE ORIGINAL INNER SLIDES
    ========================================================= */

    function restoreOriginalSlides(
        projectContainer
    ) {

        if (!projectContainer) {
            return;
        }

        const wrapper =
            projectContainer.querySelector(
                '.swiper-wrapper'
            );

        if (!wrapper) {
            return;
        }

        const originalHtml =
            wrapper.dataset.originalHtml;

        if (
            !originalHtml
        ) {
            return;
        }

        wrapper.innerHTML =
            originalHtml;

    }


    /* =========================================================
       FILTER INNER SLIDES
    ========================================================= */

    function filterInnerSlides(
        projectContainer
    ) {

        if (!projectContainer) {
            return;
        }

        const wrapper =
            projectContainer.querySelector(
                '.swiper-wrapper'
            );

        if (!wrapper) {
            return;
        }


        /*
         * Eerst originele slides herstellen.
         *
         * Hierdoor verdwijnen oude filters.
         */

        restoreOriginalSlides(
            projectContainer
        );


        const slides =
            Array.from(
                wrapper.querySelectorAll(
                    '.project-image-slide'
                )
            );


        slides.forEach(
            function (slide) {

                if (
                    !imageIsAllowed(slide)
                ) {

                    /*
                     * Echt uit de DOM verwijderen.
                     *
                     * Daardoor ziet Swiper deze slide
                     * helemaal niet meer.
                     */

                    slide.remove();

                }

            }
        );


        /*
         * Overgebleven slides opnieuw indexeren.
         */

        const remainingSlides =
            wrapper.querySelectorAll(
                '.project-image-slide'
            );


        remainingSlides.forEach(
            function (slide, index) {

                slide.dataset.index =
                    index;

            }
        );

    }


    /* =========================================================
       RESPONSIVE IMAGE SOURCE
    ========================================================= */

    function getResponsiveImageSource(
        image
    ) {

        if (!image) {
            return null;
        }


        /* -----------------------------------------------------
           MOBILE
        ----------------------------------------------------- */

        if (isMobile()) {

            return (
                image.dataset.srcMobile ||
                image.dataset.mobile ||
                image.dataset.src ||
                null
            );

        }


        /* -----------------------------------------------------
           TABLET PORTRAIT
        ----------------------------------------------------- */

        if (
            isTablet() &&
            !isTabletLandscape()
        ) {

            return (
                image.dataset.srcTablet ||
                image.dataset.tablet ||
                image.dataset.src ||
                null
            );

        }


        /* -----------------------------------------------------
           DESKTOP + TABLET LANDSCAPE
        ----------------------------------------------------- */

        return (
            image.dataset.srcDesktop ||
            image.dataset.desktop ||
            image.dataset.src ||
            null
        );

    }


    /* =========================================================
       PICTURE SOURCE ACTIVATION
    ========================================================= */

    function activatePictureSources(
        image
    ) {

        if (!image) {
            return;
        }

        const picture =
            image.closest(
                'picture'
            );

        if (!picture) {
            return;
        }

        const sources =
            picture.querySelectorAll(
                'source'
            );

        sources.forEach(
            function (sourceElement) {

                const lazySrcset =
                    sourceElement.dataset.srcset;

                if (
                    lazySrcset &&
                    sourceElement.srcset !== lazySrcset
                ) {

                    sourceElement.srcset =
                        lazySrcset;

                }

            }
        );

    }


    /* =========================================================
       SET IMAGE SOURCE
    ========================================================= */

    function setPictureSource(
        slide
    ) {

        if (!slide) {
            return;
        }

        const image =
            slide.querySelector(
                '.project-image'
            );

        if (!image) {
            return;
        }

        const source =
            getResponsiveImageSource(
                image
            );

        if (!source) {
            return;
        }

        activatePictureSources(
            image
        );

        if (
            image.dataset.activeSrc === source
        ) {
            return;
        }

        image.dataset.activeSrc =
            source;

        image.src =
            source;

    }


    /* =========================================================
       LOAD IMAGE
    ========================================================= */

    function loadImage(
        slide
    ) {

        if (!slide) {
            return Promise.resolve(false);
        }

        /*
         * Verboden slides zouden normaal al uit de DOM zijn.
         */

        if (
            !imageIsAllowed(slide)
        ) {
            return Promise.resolve(false);
        }

        const image =
            slide.querySelector(
                '.project-image'
            );

        if (!image) {
            return Promise.resolve(false);
        }

        setPictureSource(
            slide
        );

        const src =
            getResponsiveImageSource(
                image
            );

        if (!src) {
            return Promise.resolve(false);
        }

        if (
            image.dataset.loaded === 'true' &&
            image.dataset.activeSrc === src &&
            image.complete &&
            image.naturalWidth > 0
        ) {

            return Promise.resolve(true);

        }

        if (
            image._imagePromise &&
            image.dataset.loadingSrc === src
        ) {

            return image._imagePromise;

        }

        image.dataset.loadingSrc =
            src;

        image.dataset.loading =
            'true';

        $(slide).addClass(
            'is-loading'
        );


        image._imagePromise =
            new Promise(
                function (resolve) {

                    if (
                        image.complete &&
                        image.naturalWidth > 0 &&
                        image.dataset.activeSrc === src
                    ) {

                        image.dataset.loaded =
                            'true';

                        image.dataset.loading =
                            'false';

                        $(slide)
                            .removeClass(
                                'is-loading'
                            )
                            .addClass(
                                'is-loaded'
                            );

                        image._imagePromise =
                            null;

                        resolve(true);

                        return;

                    }


                    image.onload =
                        function () {

                            if (
                                image.dataset.loadingSrc !==
                                src
                            ) {

                                image._imagePromise =
                                    null;

                                resolve(false);

                                return;

                            }

                            image.dataset.loaded =
                                'true';

                            image.dataset.loading =
                                'false';

                            image.dataset.activeSrc =
                                src;

                            $(slide)
                                .removeClass(
                                    'is-loading is-error'
                                )
                                .addClass(
                                    'is-loaded'
                                );

                            image._imagePromise =
                                null;

                            resolve(true);

                        };


                    image.onerror =
                        function () {

                            image.dataset.loading =
                                'false';

                            $(slide)
                                .removeClass(
                                    'is-loading'
                                )
                                .addClass(
                                    'is-error'
                                );

                            image._imagePromise =
                                null;

                            resolve(false);

                        };


                    if (
                        image.src !== src
                    ) {

                        image.src =
                            src;

                    }

                }
            );

        return image._imagePromise;

    }


    /* =========================================================
       LOAD NEARBY
    ========================================================= */

    function loadNearbyImages(
        swiper
    ) {

        if (
            !swiper ||
            !swiper.slides ||
            !swiper.slides.length
        ) {
            return;
        }

        const index =
            swiper.activeIndex;


        if (
            swiper.slides[index]
        ) {

            loadImage(
                swiper.slides[index]
            );

        }


        if (
            swiper.slides[index - 1]
        ) {

            loadImage(
                swiper.slides[index - 1]
            );

        }


        if (
            swiper.slides[index + 1]
        ) {

            loadImage(
                swiper.slides[index + 1]
            );

        }

    }


    /* =========================================================
       INNER SWIPERS
    ========================================================= */

    let activeDesktopSwiper =
        null;

    let activeDesktopProject =
        null;

    let activeMobileSwiper =
        null;

    let activeMobileProject =
        null;


    /* =========================================================
       DESTROY DESKTOP
    ========================================================= */

    function destroyDesktopSwiper() {

        if (!activeDesktopSwiper) {
            return;
        }

        try {

            activeDesktopSwiper.destroy(
                true,
                false
            );

        } catch (error) {}

        activeDesktopSwiper =
            null;

        activeDesktopProject =
            null;

    }


    /* =========================================================
       DESTROY MOBILE
    ========================================================= */

    function destroyMobileSwiper() {

        if (!activeMobileSwiper) {
            return;
        }

        try {

            activeMobileSwiper.destroy(
                true,
                false
            );

        } catch (error) {}

        activeMobileSwiper =
            null;

        activeMobileProject =
            null;

    }


    /* =========================================================
       PREPARE PROJECT CONTAINER
    ========================================================= */

    function prepareProjectContainer(
        projectSlide
    ) {

        if (!projectSlide) {
            return null;
        }

        const container =
            projectSlide.querySelector(
                '.swiper-container-project'
            );

        if (!container) {
            return null;
        }

        /*
         * Originele slides één keer opslaan.
         */

        storeOriginalSlides(
            container
        );

        /*
         * Filter voordat Swiper wordt aangemaakt.
         */

        filterInnerSlides(
            container
        );

        return container;

    }


    /* =========================================================
       CREATE MOBILE / TABLET PORTRAIT SWIPER
    ========================================================= */

    function createMobileSwiper(
        projectSlide
    ) {

        const element =
            prepareProjectContainer(
                projectSlide
            );

        if (!element) {
            return;
        }


        activeMobileProject =
            projectSlide;


        activeMobileSwiper =
            new Swiper(
                element,
                {

                    loop: false,

                    direction: 'vertical',

                    preloadImages: false,

                    nested: true,

                    allowTouchMove: true,

                    threshold: 20,

                    touchRatio: 1,

                    touchAngle: 35,

                    resistance: true,

                    resistanceRatio: 0.75,

                    touchReleaseOnEdges: true,

                    mousewheel: false,

                    keyboard: {
                        enabled: false
                    },

                    pagination: {

                        el:
                            element.querySelector(
                                '.swiper-pagination-project'
                            ),

                        clickable: false

                    },

                    preventClicks: false,

                    preventClicksPropagation:
                        false,

                    observer: false,

                    observeParents: false,

                    on: {

                        init:
                            function () {

                                loadNearbyImages(
                                    this
                                );

                            },

                        slideChange:
                            function () {

                                loadNearbyImages(
                                    this
                                );

                            },

                        slideChangeTransitionStart:
                            function () {

                                loadImage(
                                    this.slides[
                                        this.activeIndex
                                    ]
                                );

                            }

                    }

                }
            );


        loadNearbyImages(
            activeMobileSwiper
        );

    }


    /* =========================================================
       CREATE DESKTOP SWIPER
       DESKTOP + TABLET LANDSCAPE
    ========================================================= */

    function createDesktopSwiper(
        projectSlide
    ) {

        const element =
            prepareProjectContainer(
                projectSlide
            );

        if (!element) {
            return;
        }


        activeDesktopProject =
            projectSlide;


        activeDesktopSwiper =
            new Swiper(
                element,
                {

                    loop: false,

                    direction: 'vertical',

                    preloadImages: false,

                    nested: true,

                    allowTouchMove: true,

                    threshold: 15,

                    touchRatio: 1,

                    touchAngle: 30,

                    resistance: true,

                    resistanceRatio: 0.85,

                    touchReleaseOnEdges: true,

                    mousewheel: {

                        forceToAxis: true,

                        sensitivity: 3,

                        releaseOnEdges: true

                    },

                    keyboard: {

                        enabled: false

                    },

                    pagination: {

                        el:
                            element.querySelector(
                                '.swiper-pagination-project'
                            ),

                        clickable: true

                    },

                    preventClicks: false,

                    preventClicksPropagation:
                        false,

                    observer: false,

                    observeParents: false,

                    on: {

                        init:
                            function () {

                                loadNearbyImages(
                                    this
                                );

                            },

                        slideChange:
                            function () {

                                loadNearbyImages(
                                    this
                                );

                            },

                        slideChangeTransitionStart:
                            function () {

                                loadImage(
                                    this.slides[
                                        this.activeIndex
                                    ]
                                );

                            }

                    }

                }
            );


        loadNearbyImages(
            activeDesktopSwiper
        );

    }


    /* =========================================================
       CREATE INNER SWIPER
    ========================================================= */

    function createInnerSwiper(
        projectSlide
    ) {

        if (!projectSlide) {
            return;
        }


        /*
         * MOBILE + TABLET PORTRAIT
         */

        if (
            isMobile() ||
            (
                isTablet() &&
                !isTabletLandscape()
            )
        ) {

            destroyDesktopSwiper();

            destroyMobileSwiper();

            createMobileSwiper(
                projectSlide
            );

            return;

        }


        /*
         * DESKTOP + TABLET LANDSCAPE
         */

        destroyMobileSwiper();

        destroyDesktopSwiper();

        createDesktopSwiper(
            projectSlide
        );

    }


    /* =========================================================
       ACTIVE PROJECT
    ========================================================= */

    function getActiveProjectSlide() {

        if (
            !mySwiper ||
            !mySwiper.slides
        ) {
            return null;
        }

        return (
            mySwiper.slides[
                mySwiper.activeIndex
            ] ||
            null
        );

    }


    function loadActiveProject() {

        const activeProject =
            getActiveProjectSlide();

        if (!activeProject) {
            return;
        }

        mySwiper.update();

        window.setTimeout(
            function () {

                if (
                    getActiveProjectSlide() !==
                    activeProject
                ) {
                    return;
                }

                createInnerSwiper(
                    activeProject
                );

            },
            0
        );

    }


    /* =========================================================
       PROJECT INFO
    ========================================================= */

    function getActiveProjectSlug() {

        const slide =
            getActiveProjectSlide();

        if (!slide) {
            return null;
        }

        return (
            $(slide).attr(
                'data-project-slug'
            ) ||
            null
        );

    }


    function selectProjectTitle() {

        const projectSlug =
            getActiveProjectSlug();

        $('h2.project-title-slider')
            .hide();

        if (projectSlug) {

            $(
                '#pt-' + projectSlug
            ).show();

        }

    }


    function selectDetails() {

        const projectSlug =
            getActiveProjectSlug();

        $('header > .details > .inner-details')
            .hide();

        if (projectSlug) {

            $(
                '#details-' + projectSlug
            ).show();

        }

    }


    function updateProjectInfo() {

        selectProjectTitle();

        selectDetails();

    }


    /* =========================================================
       PROJECT COUNT
    ========================================================= */

    const projectCount =
        mySwiper.slides.length;

    let projectLoopLock =
        false;


    /* =========================================================
       FIRST PROJECT
    ========================================================= */

    function goToFirstProject() {

        if (
            projectLoopLock ||
            isMobile()
        ) {
            return;
        }

        projectLoopLock =
            true;

        mySwiper.slideTo(
            0,
            0,
            false
        );

        updateProjectInfo();

        loadActiveProject();

        window.setTimeout(
            function () {

                projectLoopLock =
                    false;

            },
            200
        );

    }


    /* =========================================================
       LAST PROJECT
    ========================================================= */

    function goToLastProject() {

        if (
            projectLoopLock ||
            isMobile()
        ) {
            return;
        }

        projectLoopLock =
            true;

        mySwiper.slideTo(
            projectCount - 1,
            0,
            false
        );

        updateProjectInfo();

        loadActiveProject();

        window.setTimeout(
            function () {

                projectLoopLock =
                    false;

            },
            200
        );

    }


    /* =========================================================
       OUTER SLIDE CHANGE
    ========================================================= */

    mySwiper.on(
        'slideChange',
        function () {

            updateProjectInfo();

            const current =
                getActiveProjectSlide();


            if (
                activeDesktopSwiper &&
                activeDesktopProject !== current
            ) {

                destroyDesktopSwiper();

            }


            if (
                activeMobileSwiper &&
                activeMobileProject !== current
            ) {

                destroyMobileSwiper();

            }


            loadActiveProject();

        }
    );


    mySwiper.on(
        'slideChangeTransitionEnd',
        function () {

            updateProjectInfo();

            loadActiveProject();

        }
    );


    /* =========================================================
       REACH END
    ========================================================= */

    mySwiper.on(
        'reachEnd',
        function () {

            if (
                projectLoopLock ||
                isMobile()
            ) {
                return;
            }

            window.setTimeout(
                function () {

                    if (
                        mySwiper.activeIndex ===
                        projectCount - 1
                    ) {

                        goToFirstProject();

                    }

                },
                120
            );

        }
    );


    /* =========================================================
       REACH BEGINNING
    ========================================================= */

    mySwiper.on(
        'reachBeginning',
        function () {

            if (
                projectLoopLock ||
                isMobile()
            ) {
                return;
            }

            window.setTimeout(
                function () {

                    if (
                        mySwiper.activeIndex === 0
                    ) {

                        goToLastProject();

                    }

                },
                120
            );

        }
    );


    /* =========================================================
       INITIAL PROJECT
    ========================================================= */

    function openInitialProject() {

        let targetIndex =
            -1;


        if (
            requestedProjectSlug &&
            mySwiper.slides[0]
        ) {

            const firstSlug =
                $(mySwiper.slides[0])
                    .attr(
                        'data-project-slug'
                    );

            if (
                firstSlug ===
                requestedProjectSlug
            ) {

                targetIndex =
                    0;

            }

        }


        if (
            targetIndex < 0 &&
            !requestedProjectSlug &&
            projectCount > 0
        ) {

            targetIndex =
                Math.floor(
                    Math.random() *
                    projectCount
                );

        }


        if (
            targetIndex < 0 &&
            projectCount > 0
        ) {

            targetIndex =
                0;

        }


        if (
            targetIndex >= 0
        ) {

            mySwiper.slideTo(
                targetIndex,
                0,
                false
            );

        }


        updateProjectInfo();


        requestAnimationFrame(
            function () {

                loadActiveProject();

            }
        );

    }


    openInitialProject();


    /* =========================================================
       DEVICE CHANGE / RESIZE / ORIENTATION
    ========================================================= */

    let resizeTimer;

    let previousDevice =
        getDeviceType();


    $(window).on(
        'resize orientationchange',
        function () {

            clearTimeout(
                resizeTimer
            );

            resizeTimer =
                setTimeout(
                    function () {

                        /*
                         * Update device-specific classes/info.
                         */

                        updateTabletLandscapeClass();

                        updateKeyboardInfoVisibility();


                        const currentDevice =
                            getDeviceType();


                        if (mySwiper) {

                            mySwiper.update();

                        }


                        /*
                         * Device verandert:
                         *
                         * Bijvoorbeeld:
                         *
                         * tablet portrait
                         * ↓
                         * tablet landscape
                         *
                         * of:
                         *
                         * desktop
                         * ↓
                         * tablet landscape
                         *
                         * De inner swiper moet opnieuw
                         * worden opgebouwd zodat filtering,
                         * image sources en Swiper-config
                         * correct veranderen.
                         */

                        if (
                            currentDevice !==
                            previousDevice
                        ) {

                            previousDevice =
                                currentDevice;


                            destroyDesktopSwiper();

                            destroyMobileSwiper();


                            loadActiveProject();

                            return;

                        }


                        /*
                         * Zelfde device, alleen viewport
                         * gewijzigd.
                         */

                        if (
                            activeDesktopSwiper
                        ) {

                            activeDesktopSwiper.update();

                            loadNearbyImages(
                                activeDesktopSwiper
                            );

                        }


                        if (
                            activeMobileSwiper
                        ) {

                            activeMobileSwiper.update();

                            loadNearbyImages(
                                activeMobileSwiper
                            );

                        }

                    },
                    250
                );

        }
    );


    /* =========================================================
       PROJECT CLOSE
    ========================================================= */

    $(document).on(
        'click',
        '#3',
        function (e) {

            e.preventDefault();
            e.stopPropagation();

            if (
                window.history.length > 1
            ) {

                window.history.back();

            } else {

                window.location.href =
                    '/';

            }

        }
    );


    /* =========================================================
       KEYBOARD NAVIGATION
    ========================================================= */

    $(document).on(
        'keydown',
        function (event) {

            /*
             * Alleen echte desktop.
             *
             * Tablet landscape krijgt GEEN keyboard navigation,
             * ondanks het feit dat het verder desktop-gedrag gebruikt.
             */

            if (!isDesktop()) {
                return;
            }


            if (
                $('header').hasClass(
                    'menuopen'
                ) ||
                $('header').hasClass(
                    'contactopen'
                ) ||
                $('header').hasClass(
                    'detailsopen'
                )
            ) {
                return;
            }


            /*
             * INNER VERTICAAL
             */

            if (
                event.key === 'ArrowUp' ||
                event.key === 'ArrowDown'
            ) {

                if (
                    !activeDesktopSwiper
                ) {
                    return;
                }

                if (
                    activeDesktopSwiper.animating
                ) {

                    event.preventDefault();

                    return;

                }

                event.preventDefault();
                event.stopPropagation();


                if (
                    event.key === 'ArrowUp'
                ) {

                    activeDesktopSwiper.slidePrev();

                } else {

                    activeDesktopSwiper.slideNext();

                }

                return;

            }


            /*
             * OUTER HORIZONTAAL
             */

            if (
                event.key === 'ArrowLeft'
            ) {

                if (
                    mySwiper.animating
                ) {

                    event.preventDefault();

                    return;

                }

                event.preventDefault();
                event.stopPropagation();

                mySwiper.slidePrev();

                return;

            }


            if (
                event.key === 'ArrowRight'
            ) {

                if (
                    mySwiper.animating
                ) {

                    event.preventDefault();

                    return;

                }

                event.preventDefault();
                event.stopPropagation();

                mySwiper.slideNext();

                return;

            }

        }
    );


    /* =========================================================
       INITIAL
    ========================================================= */

    updateProjectInfo();

    updateTabletLandscapeClass();

    updateKeyboardInfoVisibility();

});